import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { FileDropZone } from '../../components/file_drop_zone';
import { StackOfDocumentsSolidIcon } from '../../icons';
const MAX_FILES = 15;
const DEFAULT_DESCRIPTION = 'Once a source map is uploaded the AI agent will automatically process signature fields, metadata, and site assignments.';
export const CONSENT_MANAGER_UPLOAD_DESCRIPTION = 'Uploading adds a draft template for each PDF. A spreadsheet in the same batch stores sites on those templates. It does not assign sites in the study, detect signature areas, or read locale, version, or version date. Use Locate signature fields in the editor to place signature areas.';
const ACCEPTED_TYPES = [
    '.pdf',
    '.docx',
    '.xls',
    '.xlsx',
    '.csv',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
];
export const ConsentUploadZone = ({ onFileAdd, description }) => {
    const translate = useLocalizeMessage();
    const handleUpload = async (files) => {
        await onFileAdd(files);
    };
    return (_jsx("div", { className: 'nucleus-mb-6', children: _jsx(FileDropZone, { onUpload: handleUpload, title: translate('Add files here or click to upload consent templates'), description: description ?? translate(DEFAULT_DESCRIPTION), acceptedFileTypes: ACCEPTED_TYPES.join(','), acceptedExtensions: ['PDF', 'DOCX', 'XLS', 'XLSX', 'CSV'], maxFileSize: 25, maxFiles: MAX_FILES, icon: _jsx("span", { style: { color: '#D4C9FF' }, children: _jsx(StackOfDocumentsSolidIcon, { size: 60 }) }) }) }));
};
